import React from "react";
import AzureContent from "../function-components/azure/AzureContent";

function Azure() {
 return (
  <>
   <AzureContent />
  </>
 );
}

export default Azure;
